import { NgModule, SkipSelf, Optional } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeComponent } from "./home/home.component";
import { CoreRoutingModule } from "./core-routing.module";
import { HeaderBarComponent } from "./header-bar/header-bar.component";
import { MaterialModule } from "../shared/material.module";
import { UserMenuComponent } from "./header-bar/user-menu/user-menu.component";
import { UnauthenticatedUserMenuComponent } from "./header-bar/unauthenticated-user-menu/unauthenticated-user-menu.component";
import { ServiceProviderModule } from "../service-provider/service-provider.module";
import { SideNavComponent } from "./nav/side-nav/side-nav.component";
import { SharedModule } from "../shared/shared.module";
import { UserModule } from "../user/user.module";
import { PromoImageHeaderComponent } from "./promo-image-header/promo-image-header.component";

@NgModule({
  declarations: [
    HomeComponent,
    HeaderBarComponent,
    UserMenuComponent,
    UnauthenticatedUserMenuComponent,
    SideNavComponent,
    PromoImageHeaderComponent
  ],
  imports: [
    CommonModule,
    CoreRoutingModule,
    MaterialModule,
    ServiceProviderModule,
    SharedModule,
    UserModule
  ],
  exports: [HeaderBarComponent, SideNavComponent]
})
export class AppCoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppCoreModule
  ) {
    // Import guard
    if (parentModule) {
      throw new Error(
        `${parentModule} has already been loaded. Import Core module in the AppModule only.`
      );
    }
  }
}
